<template>
    <div :class="$style.wrapper">
        <h1 class="crumb">所有成员</h1>
        <div :class="$style.bar">
            <div :class="$style.btnGroup">
                <StaffForm :title="'添加员工'"><el-button class="btn">添加员工</el-button></StaffForm>
                <el-button @click="$router.push('/SetPosition')" class="btn">设置</el-button>
            </div>
            <!-- <div :class="$style.search">
                <el-input
                    placeholder="请输入员工名称/员工号"
                    v-model="content"
                    clearable>
                </el-input>
                <el-button>搜索</el-button>
            </div> -->
        </div>
        <div :class="$style.table">
            <el-table style="width: 100%" :data="tableData" size="small">
                <el-table-column align="center" label="姓名">
                    <template slot-scope="scope">
                        <!-- <img :class="$style.avatar" :src="scope.row.avatar" alt=""> -->
                        <span>{{scope.row.staff_name}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="员工号" prop="staff_id"></el-table-column>
                <el-table-column align="center" label="手机号" prop="mobile"></el-table-column>
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <a @click="modify(scope.row)">编辑</a>
                       <!--  <StaffForm
                        :title="'编辑员工'"
                        :scope='scope.row'
                        ><a>编辑</a></StaffForm> -->
                        <a style="margin: 0 3px;">|</a>
                        <a @click="deleat(scope.row.staff_id)">删除</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
         <!-- 修改员工信息 -->
            <div clss='boxt'>
                <el-dialog title="编辑员工" :visible.sync="dialogFormVisible">
                    <div class="bosform">
                        <el-form :model="formList" size="small" label-width="80px" label-position="right">
                            <el-form-item label="姓名：">
                                <el-input v-model='formList.staff_name'></el-input>
                            </el-form-item>
                            <el-form-item label="手机号：">
                                <el-input v-model='formList.mobile'></el-input>
                            </el-form-item>
                            <el-form-item label="权限：">
                                <el-select v-model="formList.position_id" placeholder="请选择">
                                    <el-option
                                      v-for="item in options"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="密码：">
                                <el-input v-model='formList.password' type='password'></el-input>
                            </el-form-item>
                          </el-form>
                    </div>
                    <div class="yx-popover-btnGroup">
                        <el-button :loading="btnLoading" :class="['orangeBtn', 'yx-popover-btn']"  @click="suremodify()">确定</el-button>
                        <el-button :class="['btn', 'yx-popover-btn', 'yx-popover-cancelBtn']" @click="dialogFormVisible=false">取消</el-button>
                    </div>
                  <!-- <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="suremodify()">确 定</el-button>
                  </div> -->
                </el-dialog>
            </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage1"
          :page-size="100"
          layout="total, prev, pager, next"
          :total="1">
        </el-pagination>
    </div>
</template>

<script>
    import { session_id } from '../../stores/api';
    import Vue from 'vue';
    import Pagination from '../Common/Pagination.vue';
    import Confirm from '../Common/Confirm.vue';
    import StaffForm from './StaffForm.vue';

    Vue.component('Pagination', Pagination);
    Vue.component('Confirm', Confirm);
    Vue.component('StaffForm', StaffForm);
    export default {
         props: ['title', 'confirmText', 'handleSubmit','name','qunx','phone','password'],
        data () {

            return {
                dialogFormVisible:false,
                formList:[],
                page:1,
                options: [],
                position_id: '',
                tableData: [{
                    name: '萧熙',
                    avatar: '../../assets/header/avatar.png',
                    workerNo: '1005',
                    phone: '18667458350',
                }, {
                    name: '萧熙',
                    avatar: '../../assets/header/avatar.png',
                    workerNo: '1005',
                    phone: '18667458350',
                }]
            };
        },
        methods:{
            get_staff_position_list(page){
                this.$http.get(this.$reqUrl+'user.php?act=get_staff_position_list&page='+this.page+'&position_id='+0+'&session_id='+session_id)
                .then(res=>{
                    this.tableData=res.data.staff_list;
                    for(let i=0;i<res.data.staff_list.length;i++){
                        this.tableData[i].avatar='http://shop.gzestars.com'+res.data.staff_list[i].avatar
                    }
                })
            },
            handleCurrentChange(val){
                this.page=val;
                this.get_staff_position_list(page);
            },
            //删除员工
            deleat(id,page){
                this.$confirm('是否删除该员工?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning',
                  center: true
                }).then(() => {

                this.$http.get(this.$reqUrl+'user.php?act=drop_staff&session_id='+session_id+'&staff_id='+id)
                .then(res=>{
                    this.$message({
                    type: 'success',
                    message: '删除成功!'
                  });
                this.get_staff_position_list(page)
                })

                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消删除'
                  });
                });
            },
            //编辑员工信息
            modify(row){
                this.dialogFormVisible=true;
                this.formList=row;
            },
            //确定修改
            suremodify(page){
                this.$http.get(this.$reqUrl+'user.php?act=update_staff&session_id='+session_id,{params: this.formList})
                 .then(res=>{
                    this.dialogFormVisible=false;
                    this.get_staff_position_list(page);
                    this.$message({
                    type: 'success',
                    message: '编辑成功!'
                  });
                })
            },
            //获取职位列表
            getzw(){
                this.$http.get(this.$reqUrl+'user.php?act=get_staff_position_list&content='+1+'&session_id='+session_id)
                .then(res=>{
                    this.options=res.data.position_nav;
                    for(let i=0;i<res.data.position_nav.length;i++){
                      this.options = res.data.position_nav.map(item => {
                       return {value: item.position_id, label: item.position_name};
                    });
                    }
                })
            }

        },
        mounted(){
            //获取员工信息列表
            this.get_staff_position_list();
            this.getzw();
        }
    };
</script>

<style lang="less" module>
    .wrapper {
        .bar {
            display: flex;
            justify-content: space-between;
            margin-bottom: 15px;
            .btnGroup {
                button {
                    width: 100Px;
                    height: 35Px;
                    margin-right: 10Px;
                    font-size: 16px;
                    color: #ffffff;
                    background: #f56c31;
                    border-radius: 2px;
                }
            }
            .search {
                display: flex;
                input {
                    width: 300px;
                    border-radius: 0;
                    border: 1px solid #d8dde6;
                    border-right: 0;
                }
                button {
                    border-radius: 0;
                }
            }
        }

        .table {
            border:1px solid #d8dde6;
            .avatar {
                vertical-align: middle;
                margin: 10px 10px;
                border-radius: 50%;
            }
        }

    }
</style>
<style>
.el-dialog{
    width: 500px;
    margin: 0 auto 50px;
}
.bosform{
    padding: 30Px 90Px 30Px 70Px;
}
.bosform .el-input{
    width: 260px;
    height: 32px;
}
.el-dialog__body{
    padding:0;
}
.boxt .el-form-item--mini.el-form-item, .boxt .el-form-item--small.el-form-item{
    margin-bottom: 18px;
}
.boxt .el-form-item__content{
    margin-left:80px;
}
.el-dialog__body {
    padding-bottom: 30Px ;
    text-align: center;
}
.el-dialog__body input{
    border-radius: 0;
}
.yx-popover-btn {
    margin-top: 10PX;
    width:120Px;
    height:35Px;
    font-size:16px;
    color:#ffffff;
    border-radius:4px;
}
.yx-popover-cancelBtn {
    margin-left: 10px;
    background:#d8dde6;
}
</style>



// WEBPACK FOOTER //
// src/components/Management/StaffList.vue